import React from 'react';
import {
  Image,
} from '@chakra-ui/react';
import useRequest from 'shared/src/hooks/useRequest';
import HlsVideo from 'shared/src/components/HlsVideo';
import useClient from 'shared/src/hooks/useClient';

const MediaPreview = ({ src, businessId, postId }: { src: string, businessId: string, postId: string }) => {
  const client = useClient();
  const streamRequest = useRequest(
    async () => {
      if (!src) return;
      if (!src.endsWith('#stream')) return;
      if (!businessId) return;

      // eslint-disable-next-line consistent-return
      return client
        .businesses.for(businessId)
        .social.posts.for(postId)
        .getStream();
    },
    [src, businessId],
  );

  if (streamRequest.result) {
    return <HlsVideo controls poster={src} src={streamRequest.result.media[0].hls} />;
  }
  return <Image src={src} />;
};

export default MediaPreview;
